export const EXSBPRICELIST_SHOW_RESET = 'EXSBPRICELIST_SHOW_RESET'
export const EXSBPRICELIST_SHOW_SET_ERROR = 'EXSBPRICELIST_SHOW_SET_ERROR'
export const EXSBPRICELIST_SHOW_SET_RETRIEVED = 'EXSBPRICELIST_SHOW_SET_RETRIEVED'
export const EXSBPRICELIST_SHOW_TOGGLE_LOADING = 'EXSBPRICELIST_SHOW_TOGGLE_LOADING'
